import React from 'react';
import { AVAILABLE_SCHEMES } from '../theme/colorSchemes';
import { applySchemeToDocument, useColorScheme } from '../theme/useColorScheme';
import styles from './AppearanceSelect.module.scss';

const AppearanceSelect: React.FC = () => {
  const scheme = useColorScheme((s) => s.scheme);
  const setScheme = useColorScheme((s) => s.setScheme);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const next = e.target.value as typeof scheme;
    setScheme(next);
    applySchemeToDocument(next);
  };

  return (
    <div className={styles.wrapper}>
      <span className={styles.label}>Theme</span>
      <select className={styles.select} value={scheme} onChange={handleChange} aria-label="Appearance">
        {AVAILABLE_SCHEMES.map((s) => (
          <option key={s.value} value={s.value}>
            {s.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AppearanceSelect;


